import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {IconsModule} from '../icons/icons.module';
import {OfferPetalComponent} from './offer-petal.component';
import {PrimePetalLongModule} from '../prime-petal-long/prime-petal-long.module';

@NgModule({
  declarations: [OfferPetalComponent],
  imports: [CommonModule, IconsModule, RouterModule, PrimePetalLongModule],
  exports: [OfferPetalComponent],
})
export class OfferPetalModule {}
